import { type ActivityItem, type ActivityItemOf } from '@/platform/learning/contract'

/** The EN-CHOICE family (Exercise Catalog §4.1): text and picture choice. */
export type ChoiceItem = ActivityItemOf<'text_choice'> | ActivityItemOf<'picture_choice'>

export function isChoiceItem(item: ActivityItem): item is ChoiceItem {
  return item.activity_type === 'text_choice' || item.activity_type === 'picture_choice'
}

/** Selection limits as authored; picture choice is single-select (D-11). */
export function selectionLimits(item: ChoiceItem): { min: number; max: number } {
  return item.activity_type === 'text_choice'
    ? { min: item.min_selections, max: item.max_selections }
    : { min: 1, max: 1 }
}

/** Usability check only; the service validates the response again. */
export function selectionIsComplete(
  item: ChoiceItem,
  selected: readonly string[],
): boolean {
  const { min, max } = selectionLimits(item)
  return selected.length >= min && selected.length <= max
}
